import React from 'react';
import Image from 'components/Image';
import {
  ArtworkThumbnail,
  DeleteIconStyled,
  HoverOption,
} from 'styles/components/ArtWork/artworksLibraryItem';

const ArtworksLibraryItem = ({
  libraryFiles = [],
  onDeleteImage,
  onSelect,
  viewOnly = false,
}) =>
  libraryFiles?.map((l, index) => (
    <ArtworkThumbnail key={`library${index}`}>
      <div>
        {onDeleteImage && !viewOnly && (
          <DeleteIconStyled
            onClick={() => onDeleteImage(l.public_id)}
          ></DeleteIconStyled>
        )}
        <Image
          src={l.secure_url}
          alt={l.asset_id}
          imageStyle={{ objectFit: 'contain' }}
        />
      </div>
      <div className="name">{l.public_id?.split('/ArtFiles/')[1]}</div>
      <HoverOption>
        <div onClick={() => onSelect(l)}>
          {viewOnly ? 'Download' : 'Select'}
        </div>
      </HoverOption>
    </ArtworkThumbnail>
  ));

export default ArtworksLibraryItem;
